import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  @Input() params:any
  constructor(private modal: NzModalRef<any>) { }

  ngOnInit(): void {
  }
  eliminarUsuario(){
  this.modal.close(this.params)
  }
  cerrarModal(){
this.modal.close(false)
  }

}
